export const slaPercentageTooltipText = `"Service-Level" is your goal for satisfactory time of an answer on
  various conversation types and can be set individually for each queue.\n\n"The Service-Level"
  is defined as the percentage of conversations answered within a predefined amount of time.\n\nAn
  often used "Service-Level" is for instance: "_We want to answer 80 % of our support calls within 20 seconds_".`;

export const longestWaitTooltipText = `"Current longest Wait in a queue" describes the maximum time a
  conversation is allowed to wait in a queue before an alert is triggered.`;

export const availableAgentsTooltipText = `The minimum number of "Available Agents" before an alert is triggered.`;

export const waitingConversationsTooltipText = `The "Maximum Conversations Allowed Waiting" in queue before
  an alert is triggered.`;
